import React, { useCallback } from 'react';
import { useState } from 'react';
import { isInvalidPriceChar } from '../../utils/PriceValidator';
import { toast } from 'react-toastify';

import dayjs from 'dayjs';
import badMutable from 'dayjs/plugin/badMutable';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import styled from 'styled-components';
dayjs.extend(badMutable);
dayjs.extend(localizedFormat);

const AddKeyInputField = styled.input`
  height: 32px;
  background: rgba(243, 244, 246);
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  position: relative;
  padding-left: 1.225rem;
  padding-right: 2.225rem;
  max-width: 600px;
  margin-top: 8px;
  border: none;
`;

const applyDiscount = (price, percent) => {
  return price - price * (percent * 0.01);
};

const AddDiscount = ({
  showAdd,
  saveDiscount,
  rentalLength,
  basePrice,
  discounts,
}) => {
  const [days, setDays] = useState(null);
  const [percent, setPercent] = useState(null);

  const handleSave = useCallback(() => {
    console.log({ rentalLength, days });
    if (rentalLength < days) {
      return toast('Discount would not apply to current rental length', {
        type: 'error',
      });
    }

    if (days < 2) {
      return toast('Discount must be for 2 or more days', { type: 'error' });
    }

    saveDiscount(days, percent);
  }, [saveDiscount, basePrice, days, percent, rentalLength]);

  const onPriceInput = (e: any) => {
    if (isInvalidPriceChar(e.key)) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  };

  return (
    <div className="flex flex-col rounded-md my-2 p-2">
      <div className="md:flex justify-between items-center">
        <div className="w-1/3">
          <label
            htmlFor="price"
            className="self-baseline block text-sm font-medium text-gray-700"
          >
            Add a discount
          </label>
        </div>
        <div className="w-2/3">
          <div className="relative rounded-md shadow-sm">
            <AddKeyInputField
              type="text"
              name="days"
              id="days"
              placeholder="5"
              value={days}
              onKeyPress={onPriceInput}
              onChange={(e: any) => setDays(e.target.value)}
            />
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
              days
            </div>
          </div>
          <div className="mt-2 relative rounded-md shadow-sm">
            <AddKeyInputField
              type="text"
              name="percent"
              id="percent"
              placeholder="10"
              value={percent}
              onKeyPress={onPriceInput}
              onChange={(e: any) => setPercent(e.target.value)}
            />
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
              %
            </div>
          </div>
        </div>
      </div>
      <div className="justify-end mt-4 flex">
        <div className="space-x-2">
          <button
            onClick={() => showAdd(false)}
            className="bg-white py-1 px-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className=" inline-flex justify-center py-1 px-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddDiscount;
